import RetireActivityTable from 'components/retire-activity-table/retire-activity-table';
import { RETIRE_PAGE } from 'site-settings/site-navigation';
import {
  ButtonNavLink,
  ButtonsPosition
} from 'components/common/button/button';
import ArrowLeftIcon from 'components/icons/ArrowLeftIcon';

import { Wrapper, ShortContainer } from 'assets/styles/pages.style';

const RetireActivityPage = () => {
  return (
    <Wrapper>
      <ButtonsPosition position="left">
        <ButtonNavLink to={RETIRE_PAGE}>
          <ArrowLeftIcon />
        </ButtonNavLink>
      </ButtonsPosition>
      <ShortContainer>
        <RetireActivityTable />
      </ShortContainer>
    </Wrapper>
  );
};

export default RetireActivityPage;
